module.exports = __webpack_public_path__ + "static/img/219_TO8_1941_og.76be2e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/219_TO8_1941_og.jpg
// module id = yca5
// module chunks = 0